<template>
  <div class="ubv" style="height: 100%">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" v-if="funcView.depuser_location_join_dep" :disabled="!isShowBind" @click="onBindOrgan()">{{ $t('base_organ_location_item.jia_ru_bu_men') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-minus" v-if="funcView.depuser_location_quit_dep" :disabled="!isShowUnbind" @click="onUnbindOrgan()">{{ $t('base_organ_location_item.tui_chu_bu_men') }}</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_organ_location_item.xiang_mu_ming_cheng')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top" @submit.native.prevent>
        <el-form-item :label="$t('base_organ_location_item.suo_shu_gong_si')">
          <el-input v-model="formSearch.company" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_organ_location_item.fu_ze_ren')">
          <el-input v-model="formSearch.contactName" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_organ_location_item.bu_men')">
          <el-input v-model="formSearch.departmentName" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        :index="true"
        type="checkbox"
        tableCode="organ_location_item"
        v-model="tableSelect"
        :data="tableList"
        @column="setColumn"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
      ></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <select-organ-dialog v-if="dialogVisible" :organ="organ" :model="dialogModel" @success="onPageChange({ page: 1 })" @close="dialogVisible = false"></select-organ-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import selectOrganDialog from './select_organ_dialog.vue';

export default {
  mixins: [resetFormSearchMixins],
  components: { selectOrganDialog },
  props: {
    orgId: [String, Number],
    orgBy: [String],
    organ: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
      formSearch: {
        search: '',
        bizId: '',
        bizType: '',
        parentId: '',
        isAss: 1,
        pageSize: 20,
        pageNum: 1,
        company: '',
        contactName: '',
        departmentName: '',
      },
      tableSelect: [],
      tableList: [],
      totalRows: 0,
    };
  },
  computed: {
    isShowBind() {
      return this.tableSelect.length > 0 && this.tableSelect.filter((t) => t.departmentId).length === 0;
    },
    isShowUnbind() {
      return this.tableSelect.length > 0 && this.tableSelect.filter((t) => !t.departmentId).length === 0;
    },
  },
  watch: {
    organ: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.tableList = [];
      this.totalRows = 0;
      this.getLocationPage();
    }
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView('/company/organdevice');
    this.getLocationPage();
  },
  methods: {
    // 组织所有项目
    getLocationPage: function () {
      if (!this.organ.bizId) {
        return;
      }
      this.formSearch.bizId = this.organ.bizId;
      this.formSearch.bizType = this.organ.bizType;
      this.formSearch.parentId = this.organ.orgId;
      this.$getJSON(apis.deviceLocationPage, this.formSearch).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 关联部门
    onBindOrgan: function () {
      this.dialogModel.title = this.$t('base_organ_location_item.jia_ru_bu_men');
      this.dialogModel.tableSelect = this.tableSelect;
      this.dialogVisible = true;
    },
    // 删除关联
    onUnbindOrgan() {
      const tips = this.$t('base_organ_location_item.nqdyjxzdxmtcqszdbm');
      const params = this.tableSelect.map((t) => ({
        orgId: this.orgId,
        bizId: t.departmentId,
        bizType: 2,
        toBizId: t.locationId,
        toBizType: 4,
      }));
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.organDeviceBindAutoDel, params).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.$emit('success');
            this.getLocationPage();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLocationPage();
    },
  },
};
</script>

<style lang="scss">
</style>
